import { Pipe, PipeTransform } from '@angular/core';
import { VariableBenefitPaymentFrequencyEnum } from '../../../../../models/enum/shared/variable-benefit-payment-frequency.enum';

@Pipe({
  name: 'vbPaymentChangeRecurringPaymentFrequencyLabel'
})
export class VbPaymentChangeRecurringPaymentFrequencyLabelPipe implements PipeTransform {
  transform(frequency: VariableBenefitPaymentFrequencyEnum): string {
    if (frequency === VariableBenefitPaymentFrequencyEnum.Monthly) {
      return $localize`Monthly Payment`;
    } else {
      return $localize`Annual Payment`;
    }
  }
}
